<template>
  <div class="subtitle-seo-content">
    <!-- 服务优势 -->
    <section class="advantages-section">
      <div class="container">
        <h2 class="section-title">{{ $t('subtitlePage.advantages.title') }}</h2>
        <div class="advantages-grid">
          <div
            v-for="(advantage, index) in advantages"
            :key="index"
            class="advantage-item"
          >
            <Icon :name="advantage.icon" class="advantage-icon" />
            <span>{{ advantage.text }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 格式卡片 -->
    <SubtitleFormatCards />

    <!-- 适用场景 -->
    <SubtitleScenarios />

    <!-- FAQ -->
    <section class="faq-section">
      <div class="container">
        <SubtitleFAQ />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import SubtitleFormatCards from './SubtitleFormatCards.vue'
import SubtitleScenarios from './SubtitleScenarios.vue'
import SubtitleFAQ from './SubtitleFAQ.vue'

import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const advantages = [
  {
    icon: 'material-symbols:check-circle',
    text: t('subtitlePage.advantages.items.0')
  },
  {
    icon: 'material-symbols:check-circle',
    text: t('subtitlePage.advantages.items.1')
  },
  {
    icon: 'material-symbols:check-circle',
    text: t('subtitlePage.advantages.items.2')
  },
  {
    icon: 'material-symbols:check-circle',
    text: t('subtitlePage.advantages.items.3')
  }
]
</script>

<style scoped lang="scss">
.subtitle-seo-content {
  background: $gray-50;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 $spacing-lg;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  color: $gray-900;
  margin-bottom: $spacing-xl;
}

.advantages-section {
  padding: $spacing-xxl 0;
  background: linear-gradient(135deg,
    rgba(#8B5CF6, 0.08) 0%,
    rgba(#4A90E2, 0.08) 100%);
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: $spacing-lg;
}

.advantage-item {
  display: flex;
  align-items: center;
  gap: $spacing-md;
  padding: $spacing-lg;
  background: $white;
  border-radius: $border-radius-lg;
  box-shadow: $shadow-sm;
  transition: all 0.3s ease;
  border-left: 4px solid #8B5CF6;

  &:hover {
    transform: translateY(-3px);
    box-shadow: $shadow-md;
  }

  .advantage-icon {
    color: #8B5CF6;
    font-size: 1.75rem;
    flex-shrink: 0;
  }

  span {
    font-size: 0.95rem;
    color: $gray-700;
    line-height: 1.6;
  }
}

@media (max-width: 768px) {
  .advantages-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    font-size: 1.75rem;
  }
}
</style>
